import React from 'react';

const PRIORITY_BADGE = {
  Critical: 'bg-red-50 text-red-700 border border-red-200',
  Major:    'bg-yellow-50 text-yellow-700 border border-yellow-200',
  Minor:    'bg-green-50 text-green-700 border border-green-200',
};

const STATUS_BADGE = {
  Open:      'bg-blue-50 text-blue-700 border border-blue-200',
  Ongoing:   'bg-yellow-50 text-yellow-700 border border-yellow-200',
  Blocked:   'bg-red-50 text-red-700 border border-red-200',
  'On Hold': 'bg-orange-50 text-orange-700 border border-orange-200',
  Closed:    'bg-gray-100 text-gray-500 border border-gray-200',
};

export default function SubtaskCard({ subtask, onOpen }) {
  const isOverdue =
    subtask.due_date &&
    subtask.status !== 'Closed' &&
    new Date(subtask.due_date) < new Date();

  const initials = subtask.assignee_name
    ? subtask.assignee_name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <tr
      className="hover:bg-gray-50 transition cursor-pointer group"
      onClick={() => onOpen(subtask)}
    >
      {/* Title */}
      <td className="py-3.5 px-4">
        <p className="font-semibold text-gray-800 text-sm truncate max-w-[200px] group-hover:text-[#7AA33E] transition-colors">
          {subtask.title}
        </p>
      </td>

      {/* Assigned Employee */}
      <td className="py-3.5 px-4">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-full bg-[#e5f3d4] flex items-center justify-center text-[#7AA33E] font-bold text-xs flex-shrink-0">
            {initials}
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">{subtask.assignee_name || '—'}</p>
            {subtask.assignee_employee_id && (
              <p className="text-xs text-gray-400">{subtask.assignee_employee_id}</p>
            )}
          </div>
        </div>
      </td>

      {/* Priority */}
      <td className="py-3.5 px-4">
        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${PRIORITY_BADGE[subtask.priority] || 'bg-gray-100 text-gray-500'}`}>
          {subtask.priority}
        </span>
      </td>

      {/* Status */}
      <td className="py-3.5 px-4">
        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${STATUS_BADGE[subtask.status] || 'bg-gray-100 text-gray-500'}`}>
          {subtask.status}
        </span>
      </td>

      {/* Due Date */}
      <td className="py-3.5 px-4">
        {subtask.due_date ? (
          <div className={`flex items-center gap-1 text-xs font-medium ${isOverdue ? 'text-red-600' : 'text-gray-500'}`}>
            {isOverdue && (
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              </svg>
            )}
            {new Date(subtask.due_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
          </div>
        ) : (
          <span className="text-gray-300 text-xs">—</span>
        )}
      </td>

      {/* Created By */}
      <td className="py-3.5 px-4 text-gray-500 text-xs">{subtask.created_by_name || '—'}</td>

      {/* Actions */}
      <td className="py-3.5 px-4">
        <button
          onClick={(e) => { e.stopPropagation(); onOpen(subtask); }}
          className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-[#7AA33E] text-white font-semibold hover:bg-[#6a9335] transition"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          View
        </button>
      </td>
    </tr>
  );
}
